import React, { ReactElement } from 'react'
import { withStyles } from '@material-ui/core'

import { styles } from './styles'
import { DELIVERED, READ } from 'constants/statuses'
import { DeliveredStatusIcon, ReadStatusIcon, SentStatusIcon, TranslatedStatusIcon } from 'uiKit/icons/StatusIcons.ts'
import ReactionIconTooltip from 'uiKit/ReactionBar/ReactionIconTooltip'
import { ReactionType } from 'models/MessageTypes'
import { TextMessageType } from 'models/ChatMessagesTypes'
import QuickReplyList from '../QuickReplyList'

interface Props {
  classes: any
  isReceived: boolean
  lastEventAt: string
  status: string
  children: ReactElement
  enableReaction: boolean
  reaction: ReactionType
  showReactionElementText: boolean
  message: TextMessageType
  postbackIds: string[],
  isTranslated: boolean
  isAdmin?: boolean
  isAiFeedbackEnabled?: boolean
  feedback?: {
    status: string
    at: string
  }
}

const MessageWrap: React.FC<Props> = props => {
  const {
    classes,
    isReceived,
    lastEventAt,
    children,
    status,
    enableReaction,
    reaction,
    showReactionElementText,
    message,
    postbackIds,
    isTranslated,
    isAdmin,
    isAiFeedbackEnabled,
  } = props

  const renderStatus = (status: string) => {
    if (status === DELIVERED) {
      return <DeliveredStatusIcon />
    } else if (status === READ) {
      return <ReadStatusIcon />
    }

    return <SentStatusIcon />
  }

  const getFeedbackIcon = (status: string) => {
    if (status === 'NEEDS_REVIEW') {
      return '/images/platform/thumb_down.svg'
    }
    return '/images/platform/thumb_up.svg'
  }

  const getFeedbackText = (status: string) => {
    if (status === 'NEEDS_REVIEW') {
      return 'Less Useful'
    }
    return 'Useful'
  }

  return (
    <>
      <div className={isReceived ? classes.containerReceived : classes.containerSend}>
        {enableReaction &&
          <ReactionIconTooltip
            reaction={reaction}
            showReactionElementText={showReactionElementText}
          />
        }
        {children && (
          <div className={classes.statusWrap}>
            {lastEventAt && <span className={classes.timeZone}>{lastEventAt}</span>}
            {!isReceived && renderStatus(status)}
            {isTranslated && <div className={`${classes.iconWithTooltip} ${classes.iconWithTooltipHover}`}>
              <TranslatedStatusIcon />
              <div className={`${classes.tooltip}`}>This message was automatically translated</div>
            </div>}
          </div>
        )}
        {children}
      </div>
      {isAdmin && isAiFeedbackEnabled && props.feedback && !isReceived && (
        <div className={classes.feedbackContainer}>
          <span className={classes.feedbackLabel}>User feedback:</span>
          <div className={classes.feedbackContent}>
            <img src={getFeedbackIcon(props.feedback.status)} className={classes.feedbackIcon} alt="feedback" />
            <span className={classes.feedbackStatus}>{getFeedbackText(props.feedback.status)}</span>
          </div>
        </div>
      )}
      <QuickReplyList
        quickReplies={message.quickReplies}
        postbackIds={postbackIds}
      />
    </>
  )
}

export default withStyles(styles)(MessageWrap)
